'use client'

import { LockScreen } from '@/components/layout/lock/LockScreen'
import { ReactNode } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { useLockScreen } from '@/components/layout/global/hooks/useLockScreen'

export type LockScreenProviderProps = {
  children?: ReactNode
  className?: string
}

export function LockScreenProvider({ children, className }: LockScreenProviderProps) {
  const [locked, setLocked] = useLockScreen(false)
  useHotkeys('ctrl+alt+l', () => setLocked(true))
  if (locked) {
    return (
      <LockScreen
        className={className}
        onUnlock={() => {
          setLocked(false)
        }}
      />
    )
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
